module.exports = __webpack_public_path__ + "img/F.7771b2e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/F.jpg
// module id = s5zv
// module chunks = 1